module.exports = __webpack_public_path__ + "static/media/1.d3a770c2.jpg";